import * as media from '../../assets/career/media';

export interface ICareerPerson {
  slug: string;
  name: string;
  role: string;
  position: string;
  image: string;
  srcSet: string;
}
export const people: readonly ICareerPerson[] = [
  {
    slug: 'natalia',
    name: 'Наташа',
    role: 'Руководитель направления коммерческой недвижимости',
    position: 'is-1st',
    image: media.mainPeopleCardImageIsNatalia,
    srcSet: [
      media.mainPeopleCardImageIsNataliaP500 + ' 500w',
      media.mainPeopleCardImageIsNataliaP800 + ' 800w',
      media.mainPeopleCardImageIsNatalia + ' 840w',
    ].join(', '),
  },
  {
    slug: 'nikita',
    name: 'Никита',
    role: 'Руководитель группы аналитики монетизации',
    position: 'is-2nd',
    image: media.mainPeopleCardImageIsNikita,
    srcSet: [
      media.mainPeopleCardImageIsNikitaP500 + ' 500w',
      media.mainPeopleCardImageIsNikitaP800 + ' 800w',
      media.mainPeopleCardImageIsNikita + ' 840w',
    ].join(', '),
  },
  {
    slug: 'veronica',
    name: 'Вероника',
    role: 'Руководитель направления «Пользовательский опыт»',
    position: 'is-3rd',
    image: media.mainPeopleCardImageIsVeronica,
    srcSet: [
      media.mainPeopleCardImageIsVeronicaP500 + ' 500w',
      media.mainPeopleCardImageIsVeronicaP800 + ' 800w',
      media.mainPeopleCardImageIsVeronica + ' 840w',
    ].join(', '),
  },
  {
    slug: 'danil',
    name: 'Данил',
    role: 'Руководитель команды платформы Android',
    position: 'is-4th',
    image: media.mainPeopleCardImageIsDanil,
    srcSet: [
      media.mainPeopleCardImageIsDanilP500 + ' 500w',
      media.mainPeopleCardImageIsDanilP800 + ' 800w',
      media.mainPeopleCardImageIsDanil + ' 840w',
    ].join(', '),
  },
  {
    slug: 'dima',
    name: 'Дима',
    role: 'Руководитель бренд-маркетинга',
    position: 'is-5th',
    image: media.mainPeopleCardImageIsDima,
    srcSet: [
      media.mainPeopleCardImageIsDimaP500 + ' 500w',
      media.mainPeopleCardImageIsDimaP800 + ' 800w',
      media.mainPeopleCardImageIsDima + ' 840w',
    ].join(', '),
  },
];
